import { 
    View,
    Badge,
    Button,
    Text,
} from "@aws-amplify/ui-react"
import { react } from "@babel/types"
import styled from "styled-components"
import { IEnergyProduct, ISaltProduct } from "../interfaces"

interface ISingleProduct {
    numInBasket: number,
    addFunc: (amount: number) => void,
    info: IEnergyProduct | ISaltProduct | undefined;
}

interface ISingleProductSafe {
    numInBasket: number,
    addFunc: (amount: number) => void,
    info: IEnergyProduct | ISaltProduct;
}

interface IProductPropsOLD {
    numGels: number,
    numBars: number,
    numDrinks : number,
    addGel: (amount:number) => void
    addBar: (amount:number) => void
    addDrink: (amount:number) => void
    products: {
        bar: IEnergyProduct,
        gel: IEnergyProduct,
        drink: IEnergyProduct
    }
}

interface IProductProps {
    products : ISingleProduct[]
}

const MainView = styled(View)`
    flex-direction:row;
    display:flex;
`
const ProductHolder = styled(View)`
    flex:1;
    margin:1rem;
    display:flex;
    flex-direction:column;
    align-items:center;
    position:relative;
    max-width:120px;
`

const ImagePlaceholder = styled(View)`
    height:120px;
    width:38px;
    background-color:black;
    margin:1rem;
`

//height doesn't do anything if we add it here, it goes off aspect ratio
const ProductImageHolder = styled(View)`
    width:50px;
    margin:1rem;
    flex:1;
    img {
        max-width:100%;
    }
`

const SmallButtonL = styled(Button)`
    margin-bottom:0.2rem;
    margin-top:0.2rem;
    border-radius:20px 0px 0px 20px;
`
const SmallButtonR = styled(Button)`
    margin-bottom:0.2rem;
    margin-top:0.2rem;
    border-radius:0px 20px 20px 0px;
    border-left:none;
`

const MyBadge=styled(Badge)`
    position:absolute;
    top:110px;
    right:0px;
    background-color:red;
    color:white;
`
const SmallText = styled(Text)`
    font-size:14px;
`

const TinyText = styled(Text)`
font-size:smaller;
color:#333;
`

const Spacer = styled(View)`
    height:1rem;
`

const ButtonHolder = styled(View)`
    flex-direction:row;
`

export const Products = (props : IProductProps) => {

    const productsToUse : ISingleProductSafe[] = (props.products.filter(x => !!x.info)) as any[]
    const ProductComponents = productsToUse.map((aProduct) => {
        const productIsSalt = aProduct.info.type == "saltCapsule" || aProduct.info.type == "saltChew"
        
        return (<ProductHolder key={aProduct.info.ID || aProduct.info.name}>
            <ProductImageHolder>
                <img src={aProduct.info.imageSrc} alt={aProduct.info.description} />
            </ProductImageHolder>
            <MyBadge>{aProduct.numInBasket}</MyBadge>
            <SmallText>{aProduct.info.name}</SmallText>
            <TinyText>{productIsSalt ? (aProduct.info as ISaltProduct).saltContentMg : (aProduct.info as IEnergyProduct).kcal}{productIsSalt ? "mg" : "kcal"}</TinyText>
            <TinyText>£{aProduct.info.priceGBP}</TinyText>
            <Spacer />
            <ButtonHolder>
                <SmallButtonL size="small" onClick={() => {aProduct.addFunc(-1)}}>-</SmallButtonL>
                <SmallButtonR size="small" onClick={() => {aProduct.addFunc(1)}} >+</SmallButtonR>
            </ButtonHolder>
        </ProductHolder>)
    })

    return <MainView>
            {ProductComponents}
    </MainView>

}